import React from "react";
import classNames from "classnames";

import { Identifiable, List as L } from "@planzone/dto";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { FolderIcon } from "@common/folderIcon";
import { ToggleArrow } from "./toggleArrow";
import { Props } from "./types";
import styles from "./styles.scss";

function List({
  list,
  selectedList,
  filteredLists,
  selectList,
  depth = 0,
}: Props) {
  const isItemSelected = selectedList && selectedList.uuid === list.uuid;
  const hasSubLists = list.subLists.length > 0;
  const isListFiltered = ({ uuid }: Identifiable<L>) =>
    filteredLists ? !filteredLists.find((l) => l.uuid === uuid) : true;

  return (
    <VisibilitySwitch
      renderChildren={(isClosed, hide, show) => (
        <div
          className={classNames(styles.list, {
            [styles.selectedList]: isItemSelected,
          })}
        >
          <div
            className={styles.heading}
            style={{
              paddingLeft: `${depth * 2.6 + 1}rem`,
            }}
            onClick={() => selectList(list)}
          >
            {!depth ? (
              <div className={styles.folderIconBox}>
                <FolderIcon className={styles.folderIcon} />
              </div>
            ) : (
              <div
                className={classNames(styles.iconBox, {
                  [styles.openedIcon]: !isClosed,
                  [styles.empty]: list.subLists.length === 0,
                })}
                onClick={(e) => {
                  e.stopPropagation();
                  (isClosed ? show : hide)();
                }}
              >
                <ToggleArrow className={styles.icon} />
              </div>
            )}
            <p
              className={classNames({ [styles.selectedList]: isItemSelected })}
            >
              {list.name}
            </p>
          </div>
          {!isClosed && hasSubLists && (
            <div className={styles.subLists}>
              {list.subLists
                .filter(isListFiltered)
                .sort((current, next) =>
                  current.activityKeyRank < next.activityKeyRank ? -1 : 1,
                )
                .map((subList) => (
                  <List
                    list={subList}
                    filteredLists={filteredLists}
                    selectedList={selectedList}
                    selectList={selectList}
                    depth={depth + 1}
                  />
                ))}
            </div>
          )}
        </div>
      )}
    />
  );
}

export { List };
